import type { QuizAttemptPublic } from '@repo/types/quiz';
import type { FormatDistanceStrictUnit } from 'date-fns';

import { differenceInSeconds } from 'date-fns';

export function getQuizAttemptTimeUnit(attempt: QuizAttemptPublic): FormatDistanceStrictUnit {
  if (!attempt.completedAt) return 'second';
  const diff = differenceInSeconds(attempt.completedAt, attempt.createdAt);

  //1min
  if (diff < 60) return 'second';
  //1h
  if (diff < 60 * 60) return 'minute';

  return 'hour';
}
